<div id="purchasing-code">
  <p class="TXT_TITLE">:: Setup Purchasing Office ::</p>
  <div class="pc-actions">
    <button nz-button nzType="default" (click)="showAddForm()">
      <img
        class="iconImage"
        src="../../../../assets/icons/new.gif"
        alt="New Item Icon"
      />
      <span class="textColor ml-6">Add New Purchasing Office</span>
    </button>

    <button
      nz-button
      nzType="default"
      (click)="deleteSelected()"
      [disabled]="selectedIds.size === 0"
    >
      <img
        class="iconImage"
        src="../../../../assets/icons/del.gif"
        alt="Delete Icon"
      />
      <span class="textColor ml-6">Delete Selected Purchasing Office</span>
    </button>
  </div>

  <nz-table
    class="StyleTable w-50"
    #purchasingCodesData
    nzBordered
    [nzData]="purchasingCodes"
    [nzNoResult]="customNoDataMessage"
    [nzShowPagination]="false"
    [nzPageSize]="purchasingCodes.length"
  >
    <thead>
      <tr>
        <th class="action-col"></th>
        <th class="action-col"></th>
        <th>Purchasing Office</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let code of purchasingCodesData.data; let i = index">
        <td class="action-col">
          <button nz-button nzType="text" (click)="startEdit(code)">
            <img
              src="assets/icons/edit.gif"
              alt="Edit"
              width="14"
              height="14"
            />
          </button>
        </td>
        <td class="action-col">
          <input
            type="checkbox"
            (change)="toggleSelection(code.purchasingId)"
            [checked]="selectedIds.has(code.purchasingId)"
            *ngIf="!code.isPOAttached"
          />
        </td>
        <td>{{ code.purchasingName }}</td>
        <td>{{ code.purchasingStatus ? "Active" : "Inactive" }}</td>
      </tr>
    </tbody>
  </nz-table>

  <div class="popupStyle" *ngIf="showAddFormPopup">
    <div class="popup" (click)="closePopup()">
      <div class="popup-content" (click)="$event.stopPropagation()">
        <div class="popup-header">
          <p class="TXT_TITLE">:: ADD Purchasing Office ::</p>
          <span class="close" (click)="closePopup()">&times;</span>
        </div>
        <div class="popup-body">
          <div>
            <form
              [formGroup]="addForm"
              (ngSubmit)="addPurchasingCode()"
              class="purchasing-form"
            >
              <label> <i class="asterisk">*</i>Purchasing Office: </label>
              <input
                nz-input
                formControlName="purchasingName"
                placeholder="Enter Purchasing Office Name"
              />
              <div
                class="error"
                *ngIf="
                  addForm.get('purchasingName')?.invalid &&
                  addForm.get('purchasingName')?.touched
                "
              >
                Purchasing Office is required.
              </div>

              <label><i class="asterisk">*</i>Status:</label>
              <nz-select
                nzShowSearch
                nzPlaceHolder="Select Status"
                formControlName="purchasingStatus"
              >
                <nz-option nzLabel="Active" nzValue="true"></nz-option>
                <nz-option nzLabel="Inactive" nzValue="false"></nz-option>
              </nz-select>

              <div
                class="error"
                *ngIf="
                  addForm.get('purchasingStatus')?.invalid &&
                  addForm.get('purchasingStatus')?.touched
                "
              >
                Status is required.
              </div>

              <div style="margin-top: 10px">
                <button
                  type="submit"
                  nz-button
                  nzType="primary"
                  [disabled]="addForm.invalid"
                >
                  SAVE
                </button>
                <button
                  type="button"
                  nz-button
                  nzType="default"
                  (click)="closePopup()"
                  style="margin-left: 15px"
                >
                  Back
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
